import React, {useState, useEffect, useRef} from 'react';
import Header from '../components/Header';
import { NavLink } from 'react-router-dom';
import { P5Canvas } from "@p5-wrapper/react";

const sparkle = [
    [0, 200],
    [-25, 150],
    [-50, 100],
    [-75, 75],
    [-100, 50],
    [-150, 25],
    [-200, 0],
    [-150, -25],
    [-100, -50],
    [-75, -75],
    [-50, -100],
    [-25, -150],
    [0, -200],
    [25, -150],
    [50, -100],
    [75, -75],
    [100, -50],
    [150, -25],
    [200, 0],
    [150, 25],
    [100, 50],
    [75, 75],
    [50, 100],
    [25, 150]
]

const snake = [
    [0, 200],
    [-25, 150],
    [-50, 100],
    [-75, 75],
    [-100, 50],
    [-150, 25],
    [-200, 0],
    [-150, -25],
    [-100, -50],
    [-75, -75],
    [-50, -100],
    [-25, -150],
    [0, -200],
    [25, -150],
    [50, -100],
    [75, -75],
    [100, -50],
    [150, -25],
    [200, 0],
    [150, 25],
    [100, 50],
    [75, 75],
    [50, 100],
    [25, 150]
]

const staff = [
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0]
]

const smallCirclePos = [
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0]
]

const infinity = [
    [25, 0],
    [50, 50],
    [100, 150],
    [150, 200],
    [200, 250],
    [300, 300],
    [400, 300],
    [500, 250],
    [550, 200],
    [600, 150],
    [675, 50],
    [690, 0],
    [50, -50],
    [100, -150],
    [150, -200],
    [200, -250],
    [300, -300],
    [400, -300],
    [500, -250],
    [550, -200],
    [600, -150],
    [675, -50],
    [25, 5],
    [25, -5],
]

const inifinity_line = [
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0]
]


const Home = () => {
    const [loading, setLoading] = useState(true);
    const [showArrow, setShowArrow] = useState(true);
    const [intersecting, setIntersecting] = useState(false);
    const [intersectingSecond, setIntersectingSecond] = useState(false);
    const [intersectingThird, setIntersectingThird] = useState(false);
    const [intersectingFourth, setIntersectingFourth] = useState(false);
    const [intersectingFifth, setIntersectingFifth] = useState(false);
    const firstSectionRef = useRef(null);
    const secondSectionRef = useRef(null);
    const thirdSectionRef = useRef(null);
    const fourthSectionRef = useRef(null);
    const fifthSectionRef = useRef(null);
    console.log(intersecting)

    var sketch = useRef(
        (p5) => {
            var circleWidth = 0
            var intersectingTemp = false;
            var intersectingSecondTemp = false;
            var intersectingThirdTemp = false;
            var intersectingFourthTemp = false;
            var intersectingFifthTemp = false;
            var outerCircleRotation = Array(24).fill(0)
            var outerCirclePos = Array(24).fill([0, 0])
            var innerCircleRotation = Array(24).fill(0)
            var innerCirclePos = Array(24).fill([0, 0])
            var smallestCircleRotation = Array(24).fill(0)
            var smallestCirclePos = Array(24).fill([0, 0])

            p5.setup = () => p5.createCanvas(window.innerWidth, window.innerHeight, p5.WEBGL);

            p5.updateWithProps = props => {
                if (props.intersecting != undefined) {
                    intersectingTemp = props.intersecting;
                    intersectingSecondTemp = props.intersectingSecond;
                    intersectingThirdTemp = props.intersectingThird;
                    intersectingFourthTemp = props.intersectingFourth;
                    intersectingFifthTemp = props.intersectingFifth;
                }
            };

            p5.draw = () => {
                p5.background('#DFF3FF');
                for (let angle = 0; angle < 360; angle += 15) {
                    p5.noStroke();
                    p5.angleMode(p5.DEGREES);

                    const createShape = (num, currentRotation, currentPos) => {
                        var rotationGoal = 0;
                        var posGoal = [0, 0];
                        p5.translate(100 + window.innerWidth/5, 0);

                        if (intersectingTemp == true) {
                            rotationGoal = angle;
                            posGoal = [window.innerWidth/6 + (num == 1 ? 100 : num == 2 ? 50 : 0), 0]
                        }
                        else if(intersectingSecondTemp == true){
                            posGoal = [...sparkle[Math.floor(angle/15)]]
                            posGoal[0] = Math.round(posGoal[0] / (1 + .5 * num));
                            posGoal[1] = Math.round(posGoal[1] / (1 + .5 * num));
                        } else if(intersectingThirdTemp == true){
                            rotationGoal = angle;
                            posGoal = [Math.random() * 400, 0]
                        } else if(intersectingFourthTemp == true){
                            posGoal = [...infinity[Math.floor(angle/15)]]
                            posGoal[0] = Math.round(posGoal[0] / 2) * (num == 2 ? -1 : 1);
                            posGoal[1] = Math.round(posGoal[1] / 2);
                        } else if(intersectingFifthTemp == true){
                            rotationGoal = angle;
                            posGoal = [window.innerWidth/6 + (num == 1 ? 100 : num == 2 ? 50 : 0), 0]
                        }

                        if (rotationGoal != currentRotation){
                            if (rotationGoal > currentRotation){
                                currentRotation += rotationGoal - currentRotation > 50 ? 20 : rotationGoal - currentRotation > 20 ? 5 : 1;
                            }
                            else if(rotationGoal < currentRotation){
                                currentRotation -= rotationGoal - currentRotation < -50 ? 20 : rotationGoal - currentRotation < -20 ? 5 : 1;
                            }
                        }
                        if (posGoal[0] != currentPos[0]){
                            if (posGoal[0] > currentPos[0]){
                                currentPos[0] += posGoal[0] - currentPos[0] > 50 ? 20 : posGoal[0] - currentPos[0] > 20 ? 5 : 1;
                            }
                            else if(posGoal[0] < currentPos[0]){
                                currentPos[0] -= posGoal[0] - currentPos[0] < -50 ? 20 : posGoal[0] - currentPos[0] < -20 ? 5 : 1;
                            }
                        }
                        if (posGoal[1] != currentPos[1]){
                            if (posGoal[1] > currentPos[1]){
                                currentPos[1] += posGoal[1] - currentPos[1] > 50 ? 20 : posGoal[1] - currentPos[1] > 20 ? 5 : 1;
                            }
                            else if(posGoal[1] < currentPos[1]){
                                currentPos[1] -= posGoal[1] - currentPos[1] < -50 ? 20 : posGoal[1] - currentPos[1] < -20 ? 5 : 1;
                            }
                        }
                        
                        var offsetX = 0;
                        var offsetY = 0;
                        if(intersectingTemp == false && intersectingSecondTemp == true && num == 1){
                            offsetX = 100;
                        }
                        else if(intersectingTemp == false && intersectingSecondTemp == true && num == 2){
                            offsetX = -150;
                            offsetY = -100;
                        }
                        else if(intersectingTemp == false && intersectingSecondTemp == true && num == 3){
                            offsetX = -125;
                            offsetY = 150;
                        }

                        return [currentRotation, currentPos, offsetX, offsetY]
                    }

                    // Outer Circle
                    p5.push();
                    var currentRotation = outerCircleRotation[Math.floor(angle/15)]
                    var currentPos = [...outerCirclePos[Math.floor(angle/15)]]
                    var [currentRotation, currentPos, offsetX, offsetY] = createShape(1, currentRotation, currentPos);
                    outerCircleRotation[Math.floor(angle/15)] = currentRotation;
                    outerCirclePos[Math.floor(angle/15)] = currentPos;
                    p5.rotate(currentRotation);
                    p5.translate(currentPos[0] + offsetX, currentPos[1] + offsetY);
                    p5.fill(255, 255, 255, 75);
                    p5.circle(0, 0, 10 + window.innerWidth/120);
                    p5.fill(255, 255, 255, 150);
                    p5.circle(0, 0, window.innerWidth/120);
                    p5.pop();

                    //2nd Circle
                    p5.push();
                    var currentRotation = innerCircleRotation[Math.floor(angle/15)]
                    var currentPos = [...innerCirclePos[Math.floor(angle/15)]]
                    var [currentRotation, currentPos, offsetX, offsetY] = createShape(2, currentRotation, currentPos);
                    innerCircleRotation[Math.floor(angle/15)] = currentRotation;
                    innerCirclePos[Math.floor(angle/15)] = currentPos;
                    p5.rotate(currentRotation);
                    p5.translate(currentPos[0] + offsetX, currentPos[1] + offsetY);
                    p5.fill(255, 255, 255, 75);
                    p5.circle(0, 0, 10 + window.innerWidth/120);
                    p5.fill(255, 255, 255, 150);
                    p5.circle(0, 0, window.innerWidth/120);
                    p5.pop();

                    // Inner Circle
                    if (angle % 30 == 0){
                        p5.push();
                        var currentRotation = smallestCircleRotation[Math.floor(angle/15)]
                        var currentPos = [...smallestCirclePos[Math.floor(angle/15)]]
                        var [currentRotation, currentPos, offsetX, offsetY] = createShape(3, currentRotation, currentPos);
                        smallestCircleRotation[Math.floor(angle/15)] = currentRotation;
                        smallestCirclePos[Math.floor(angle/15)] = currentPos;
                        p5.rotate(currentRotation);
                        p5.translate(currentPos[0] + offsetX, currentPos[1] + offsetY);
                        p5.fill(255, 255, 255, 75);
                        p5.circle(0, 0, 10 + window.innerWidth/120);
                        p5.fill(255, 255, 255, 150);
                        p5.circle(0, 0, window.innerWidth/120);
                        p5.pop();
                    }
                }
                setLoading(false)
            };

            p5.windowResized = () => {
                p5.resizeCanvas(window.innerWidth, window.innerHeight);
            }

            // p5.mouseWheel = () => {
            //     //circleWidth = 5 + (document.documentElement.scrollHeight/50)
            //     console.log(document.documentElement.scrollHeight)
            // }
        }
    );

    useEffect(() => {
         const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: .1
        };
        
        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) {
                if(entry.target.id == 'first'){
                    setShowArrow(false)
                    setIntersecting(false)
                }
                if(entry.target.id == 'second'){
                    setIntersectingSecond(false);
                }
                 if(entry.target.id == 'third'){
                    setIntersectingThird(false);
                }
                if(entry.target.id == 'fourth'){
                    setIntersectingFourth(false);
                }
                if(entry.target.id == 'fifth'){
                    setIntersectingFifth(false);
                }
            } else {
                if(entry.target.id == 'first'){
                    setShowArrow(true)
                    setIntersecting(true)
                }
                if(entry.target.id == 'second'){
                    setIntersectingSecond(true);
                }
                if(entry.target.id == 'third'){
                    setIntersectingThird(true);
                }
                if(entry.target.id == 'fourth'){
                    setIntersectingFourth(true);
                }
                if(entry.target.id == 'fifth'){
                    setIntersectingFifth(true);
                } 
            }
        }, observerOptions);

        if (firstSectionRef.current !== null) {
            observer.observe(firstSectionRef.current);
        }

        if (secondSectionRef.current !== null) {
            observer.observe(secondSectionRef.current);
        }

        if (thirdSectionRef.current !== null) {
            observer.observe(thirdSectionRef.current);
        }

        if (fourthSectionRef.current !== null) {
            observer.observe(fourthSectionRef.current);
        }

        if (fifthSectionRef.current !== null) {
            observer.observe(fifthSectionRef.current);
        }
    }, []);

    return (
        <div className={`home ${!loading && "loaded"}`}>
            <div id="first" ref={firstSectionRef}>
                <Header />
                <P5Canvas sketch={sketch.current} 
                intersecting={intersecting} 
                intersectingSecond={intersectingSecond} 
                intersectingThird={intersectingThird} 
                intersectingFourth={intersectingFourth} 
                intersectingFifth={intersectingFifth}/>
                <div className={`down-container ${showArrow ? '' : 'hideArrow'}`} id="arrow">
                    <svg width="53" height="29" viewBox="0 0 53 29" fill="none" className="link" id="arrow" alt="" style={{opacity: 1}}>
                        <path d="M0.707092 1.29297L26.7839 27.3698M25.2926 27.3701L51.3694 1.29331" stroke="black" strokeWidth="2"></path>
                    </svg>
                </div>
            </div>
            <div id="second" ref={secondSectionRef}>
                <h1>"ai" does not exist</h1>
                <NavLink to="/essays/ai-linguistics" className="essay-link">linguistics of "ai"</NavLink>
                <NavLink to="/essays/wip" className="essay-link  not-done">history of "ai"</NavLink>
                <NavLink to="/essays/ai-psychiatry" className="essay-link">psychiatry & "ai"</NavLink>
                <NavLink to="/essays/ai-fascism" className="essay-link">fascism & "ai"</NavLink>
                <NavLink to="/essays/ai-after" className="essay-link">after "ai"</NavLink>
            </div>
            <div id="third" ref={thirdSectionRef}>
                <h1>"sanity" is obedience</h1>
                <NavLink to="/essays/wip" className="essay-link not-done">chatbots & therapy</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">american suicidality</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">loneliness endemic</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">incels, femcels, & romance</NavLink>
            </div>
            <div id="fourth" ref={fourthSectionRef}>
                <h1>health is interdependence</h1>
                <NavLink to="/essays/wip" className="essay-link not-done">decolonizing social prescribing</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">alone</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">death & well-being</NavLink>
            </div>
             <div id="fifth" ref={fifthSectionRef}>
                <h1>short essays</h1>
                <NavLink to="/essays/anti-intellectual" className="essay-link">anti-intellectualism & medicine</NavLink>
                <NavLink to="/essays/therapists" className="essay-link">therapy & the medical model of disability</NavLink>
                <NavLink to="/essays/chatbots-draft" className="essay-link">chatbots & therapy (draft)</NavLink>
                <NavLink to="/essays/retirement" className="essay-link">retirement</NavLink>
                <NavLink to="/essays/cowards" className="essay-link">cowards can't have ethics</NavLink>
            </div>
        </div>
    );
}

export default Home;